import React, { Component } from 'react';
import PropTypes from "prop-types";
import ReactDOM from "react-dom";

import withStyles from "@material-ui/core/styles/withStyles";

import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from 'components/CustomInput/CustomInput.jsx';
import CustomDatePicker from "components/CustomDatePicker/CustomDatePicker.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import cardStyles from "assets/jss/material-kit-pro-react/views/componentsSections/sectionCards.jsx";
import MediaQuery from 'react-responsive';

const styles = () => ({
    ...cardStyles,
    formControl: {
        "@media screen and (max-width: 600px)": {
            paddingTop: '0',
        } 
    },
    headerSearch: {
        width: '100%',
        margin: 0
    },
    cardSearchBar: {
        marginBottom: 0,
        marginTop: 0,
        borderRadius: 0,
    },
    button: {
        paddingTop: '17px',
        borderRadius: 0,
        backgroundColor: '#000000'
    },
})

class NewsSearchBar extends Component {
    constructor(props) {
        super(props);

        this.valueChange = this.valueChange.bind(this);
        this.searchKeyPress = this.searchKeyPress.bind(this);
        this.dateChange = this.dateChange.bind(this);
        this.searchButtonFocus = this.searchButtonFocus.bind(this);
        this.search = this.search.bind(this);
    }

    valueChange(e) {
        this.props.handleValueChange(e);
    }

    searchKeyPress(e) {
        if (e.key === 'Enter') {
            this.searchButton.props.onClick(e);
        }
    }

    dateChange(e) {
        if (Array.isArray(e) && e.length === 2) {
            ReactDOM.findDOMNode(this.searchButton).focus();
            this.props.handleDateChange(e);
        }
    }

    searchButtonFocus(e) {
        this.props.handleButtonFocus(e);
    }this

    search(e) {
        ReactDOM.findDOMNode(this.searchButton).focus();
        this.props.handleSearch(e);
    }

    render() {
        const { classes, startDate, endDate } = this.props;

        return (
            <div className={classes.headerSearch}>
                <div className={classes.headerContainer}>
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={12} className={`${classes.mlAuto} ${classes.mrAuto}`}>
                            <Card className={classes.cardSearchBar}>
                                <CardBody formHorizontal>
                                    <form>
                                        <GridContainer>

                                            {/* Candid title */}
                                            <GridItem xs={12} sm={2} md={2}>
                                                {/* <MediaQuery minDeviceWidth={1224}> */}
                                                <MediaQuery minWidth={1200}>
                                                    <div className="news-title">Social Sector News</div>
                                                    <div className="candid-subtitle">
                                                        powered by <span className="name">Candid.</span>
                                                    </div>
                                                </MediaQuery>
                                            </GridItem>

                                            {/* Text search bar */}
                                            <GridItem xs={12} sm={3} md={3}>
                                                <CustomInput id="search"
                                                    ref={(input) => { this.inputBox = input; }}
                                                    inputProps={{
                                                        onChange: this.valueChange,
                                                        onBlur: this.valueChange,
                                                        onKeyPress: this.searchKeyPress,
                                                        placeholder: "Search",
                                                    }} 
                                                    formControlProps={{
                                                        fullWidth: true,
                                                        className: classes.formControl
                                                    }}
                                                />
                                            </GridItem>

                                            {/* Date range filter */}
                                            {/* <GridItem xs={12} sm={3} md={3}> */}
                                            {/* Change the grid sizing below to fit in the toggle button */}
                                            <GridItem xs={12} sm={2} md={2}>
                                                <CustomDatePicker initialDate={[startDate, endDate]}
                                                    inputProps={{
                                                        onChange: this.dateChange,
                                                        placeholder: "Select date range"
                                                    }}
                                                    formControlProps={{
                                                        fullWidth: true, 
                                                        className: classes.formControl
                                                    }}

                                                />
                                            </GridItem>

                                            {/* Experimental toggle switch */}
                                            <GridItem xs={12} sm={2} md={2}>
                                                <div>
                                                    <FormControlLabel
                                                        control={
                                                            <Switch
                                                                checked={ this.props.isSwitchOn }
                                                                onChange={ this.props.handleToggleSwitch }
                                                                value="expSort"
                                                                classes={{
                                                                    switchBase: classes.switchBase,
                                                                    checked: classes.switchChecked,
                                                                    icon: classes.switchIcon,
                                                                    iconChecked: classes.switchIconChecked,
                                                                    bar: classes.switchBar
                                                                }}
                                                            />
                                                        }
                                                        classes={{
                                                            label: classes.label
                                                        }}
                                                        label="Experimental sorting"
                                                    />
                                                </div>

                                                {
                                                    this.props.isSwitchOn ?
                                                        <div>
                                                            <FormControlLabel
                                                                control={
                                                                    <Switch
                                                                        checked={ this.props.isSwitchOn && this.props.reverseSort }
                                                                        onChange={ this.props.handleSortReverse }
                                                                        value="reverseSort"
                                                                        classes={{
                                                                            switchBase: classes.switchBase,
                                                                            checked: classes.switchChecked,
                                                                            icon: classes.switchIcon,
                                                                            iconChecked: classes.switchIconChecked,
                                                                            bar: classes.switchBar
                                                                        }}
                                                                    />
                                                                }
                                                                classes={{
                                                                    label: classes.label
                                                                }}
                                                                label="Worst first"
                                                            />
                                                        </div>
                                                        : null
                                                }

                                            </GridItem>

                                            {/* Search button */}
                                            <GridItem xs={12} sm={3} md={3}>
                                                <Button
                                                    block
                                                    color="primary"
                                                    id="main-button"
                                                    className={classes.button}
                                                    onClick={ this.search }
                                                    ref={(button) => { this.searchButton = button; }}
                                                    onFocus={ this.searchButtonFocus }>
                                                    Search
                                                </Button>
                                            </GridItem>

                                        </GridContainer>
                                    </form>
                                </CardBody>
                            </Card>
                        </GridItem>
                    </GridContainer>
                </div>
            </div>
        )
    }
}

NewsSearchBar.propTypes = {
    classes: PropTypes.object,
    handleValueChange: PropTypes.func,
    handleSearchKeyPress: PropTypes.func,
    handleDateChange: PropTypes.func,
    handleSearch: PropTypes.func,
    handleButtonFocus: PropTypes.func,
    startDate: PropTypes.string,
    endDate: PropTypes.string
}

const styledComponent = withStyles(styles)(NewsSearchBar);
export default styledComponent;


// WEBPACK FOOTER //
// ./src/components/Article/SearchBar.jsx